import { Routes } from '@angular/router';

export const setupWizardRoutes: Routes = [
  {
    path: 'setup-wizard',
    loadComponent: () => import('./setup-wizard.page').then(m => m.SetupWizardPage)
  }
];
